import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import global from '@/framework/store/global'
const requireComponent = require.context('./modules', true, /\.js$/)
let modules = {}
requireComponent.keys().forEach(key => {
  if (!key.includes('index.js')) {
    modules = Object.assign(modules, requireComponent(key))
  }
})
modules.global = global
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: modules,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js